import { CSSProperties } from 'react';

import { List } from '@atom/mui';
import colors from '@atom/styles/colors';
import { SchemaTreeElementGroup } from '@atom/types/schema';
import iconUtilities from '@atom/utilities/iconUtilities';

const { ListItemButton, ListItemText } = List;

const styles = {
  listItemText: {
    marginLeft: '0.625rem',
    color: colors.neutral.gray,
    textTransform: 'uppercase' as const,
  },
};

const getRowStyle = (depth: number): CSSProperties => ({
  boxSizing: 'border-box',
  paddingLeft: `${depth * 1.5}rem`,
});

type ElementSelectionGroupRowProps = {
  group: SchemaTreeElementGroup;
  depth: number;
  isExpanded: boolean;
  onToggle: (key: string) => void;
  toggleKey: string;
};

const ElementSelectionGroupRow = ({
  group,
  depth,
  isExpanded,
  onToggle,
  toggleKey,
}: ElementSelectionGroupRowProps) => (
  <ListItemButton
    disableGutters
    style={getRowStyle(depth)}
    onClick={() => onToggle(toggleKey)}
    data-cy={`addElementGroup-${group.name}`}
  >
    {iconUtilities.leftIcon(isExpanded ? 'down-arrow' : 'right-arrow')}
    <ListItemText primary={group.name} primaryTextStyle={styles.listItemText} />
  </ListItemButton>
);

export default ElementSelectionGroupRow;
